"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cardBodyThemes = exports.baseCardBody = exports.cardHeaderThemes = exports.baseCardHeader = exports.cardThemes = exports.responsiveCard = exports.baseCard = exports.cardColorThemes = exports.ghostThemes = void 0;

var _styledComponents = require("styled-components");

var _baseColorThemes = _interopRequireDefault(require("./baseColorThemes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var ghostThemes = ['primary', 'cta', 'info', 'warning', 'danger'];
exports.ghostThemes = ghostThemes;
var cardColorThemes = [].concat(_toConsumableArray(_baseColorThemes.default), ['default'], _toConsumableArray(ghostThemes.map(function (option) {
  return "".concat(option, "Ghost");
})));
exports.cardColorThemes = cardColorThemes;
var baseCard = (0, _styledComponents.css)(["background-color:", ";border-radius:", ";border:", ";display:inline-flex;flex-direction:column;margin:", " 0;overflow:hidden;width:100%;", ";&,& *{text-align:", ";}"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.borderRadiusWide;
}, function (props) {
  return props.theme.standardButtonBorder;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.withShadow ? "box-shadow: ".concat(props.theme.s_card) : undefined;
}, function (props) {
  return props.textAlign || 'left';
});
exports.baseCard = baseCard;
var responsiveCard = (0, _styledComponents.css)(["border-radius:unset;@media only screen and (min-width:", "){border-radius:", ";}"], function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.borderRadius;
});
exports.responsiveCard = responsiveCard;
var cardThemes = (0, _styledComponents.css)(["border-color:", ";"], function (props) {
  return props.noBorder ? props.theme["c_card_".concat(props.colorTheme, "_background")] : props.theme["c_card_".concat(props.colorTheme, "_border")];
});
exports.cardThemes = cardThemes;
var baseCardHeader = (0, _styledComponents.css)(["background-color:", ";font-size:", ";font-weight:", ";overflow:hidden;padding:", ";text-overflow:ellipsis;white-space:nowrap;width:100%;"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.fontMediumSmall;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.standardPadding;
});
exports.baseCardHeader = baseCardHeader;
var cardHeaderThemes = (0, _styledComponents.css)(["border-bottom:", ";background-color:", ";&,& *{color:", ";}"], function (props) {
  return "".concat(props.theme.standardButtonBorder, " ").concat(props.theme["c_card_".concat(props.colorTheme, "_border")]);
}, function (props) {
  return props.theme["c_card_".concat(props.colorTheme, "_background")];
}, function (props) {
  return props.theme["c_card_".concat(props.colorTheme, "_text")];
});
exports.cardHeaderThemes = cardHeaderThemes;
var baseCardBody = (0, _styledComponents.css)(["height:100%;padding:", ";width:100%;"], function (props) {
  return props.theme.standardPadding;
});
exports.baseCardBody = baseCardBody;
var cardBodyThemes = (0, _styledComponents.css)(["", ";"], function (props) {
  return props.hasTitle ? null : "\n    background-color: ".concat(props.theme["c_card_".concat(props.colorTheme, "_background")], ";\n    color: ").concat(props.theme["c_card_".concat(props.colorTheme, "_text")], ";\n  ");
});
exports.cardBodyThemes = cardBodyThemes;